import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import moment from "moment";
import { parse } from "date-fns";
import SelectDropdown from "../components-react/SelectDropdown";
import {
  createFetchPlans,
  createPaymentLink,
  createPaymentLinkAdd,
} from "../../redux/reducers/postApiSlice";
import {
  checkOfferValidationByCodeData,
  checkOfferValidityByUserData,
  fetchAgreementReportData,
  fetchAllAddonSessionsData,
  fetchAllAddonSlotsData,
  fetchAllAddonsByGymData,
  fetchAllGymsData,
  fetchAllOffersByTypeIdData,
  fetchAllTrainersByExpLvlData,
  fetchAllTrainersSlotsData,
  fetchPTTrainersData,
} from "../../redux/reducers/apiSlice";
import { paymentModes, planTypes } from "../common-data/DropdowData";
import { validatePaymentLinkForm } from "../../exports/Validations";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";
import { selectAuth } from "../auth/auth.selector";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import CashVerificationQR from "./CashVerificationQR";
import { currentMonthCurrentDate } from "../common-data/Converts";
import {
  fetchIndividualTypeData,
  fetchSourceNameData,
} from "../../redux/reducers/dropdownApiSlice";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { aggrementLink } from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";

const PaymentLinkForm = ({
  paymentLinkData,
  closeModal,
  isComingPT = false,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const {
    loading,
    allAddonsByGymData,
    allAddonSessions,
    allAddonSlots,
    allOffersByTypeIdData,
    offerValidityCheckByUser,
    allTrainerByExpLvlData,
    trainerSlotDetails,
    allGymsGstIncludedData,
    allPTTrainersData,
  } = useSelector((state) => state.api);
  const { sourceNames, individualData } = useSelector(
    (state) => state.dropdown
  );
  const gymData = useSelector(selectGymData);
  const isAdmin = decryptedText?.account_type === "admin";

  const initilaPaymentLinkFormValues = {
    user_id: paymentLinkData?.user_id || "",
    selectedGym: paymentLinkData?.gym_id
      ? { value: paymentLinkData.gym_id, label: paymentLinkData.gym_name }
      : !isAdmin
      ? {
          value:
            decryptedText?.gym_id ||
            decryptedText?.user_id ||
            decryptedText?.uid,
          label: decryptedText?.gym_name,
        }
      : "",
    selSourceName: "",
    selectedPlanType: "",
    selectedPlan: "",
    selectedAddon: "",
    selectedSlotDate: "",
    selectedSlot: "",
    selectedSession: "",
    selectedSubsStartDate: "",
    selectedTrainer: "",
    selectedExtendedDays: "",
    selectedPrice: "",
    selectedPlanIndex: "",
    selectedWhatsapNo: "",
    planExpiryDate: "",
    finalBaseAmount: "",
    paymentMode: "",
    enteredCupon: "",
    description: "",
    partialCash: "",
    partialOnline: "",
    planDuration: "",
    selectedOfferIndex: "",
    selectedOfferInfo: null,
    discountableValue: "",
    trainer_exp_lvl: "",
    selectedSlotIndex: "",
    selectedSlotStartTime: "",
    selectedSlotEndTime: "",
    isWhatsapp: false,
    isPT: 0,
  };
  const [allPaymentLinkFormValues, setAllPaymentLinkFormValues] = useState(
    initilaPaymentLinkFormValues
  );
  const [selectedPlanAllPrice, setSelectedPlanAllPrice] = useState([]);
  const initialAllPansData = {
    allPlansData: [],
    allPlansDropdownData: [],
    selectedPlanInfo: [],
    extendableDaysData: [],
    // selectedPlanAllPrice: [],
  };
  const [allPlans, setAllPlans] = useState(initialAllPansData);
  const initialAddonsData = {
    allAddonsData: [],
    allAddonsDropdownData: [],
    allSessionsData: [],
    allSessionsDropdownData: [],
    allSlotsData: [],
    allSlotsDropdownData: [],
    selectedAddonSessionInfo: [],
  };
  const [allAddons, setAllAddons] = useState(initialAddonsData);
  const initialOfferDatas = {
    allOffersData: [],
    allPublicOffers: [],
    allPrivateOffers: [],
  };
  const [allOffers, setAllOffers] = useState(initialOfferDatas);
  const initialGstTableValues = {
    amount: "",
    taxableAmount: "",
    sgst: "",
    cgst: "",
    totalAmount: "",
    taxAmount: "",
  };
  const [gstTableValues, setGstTableValues] = useState(initialGstTableValues);
  const [paymentLinkFormErrors, setPaymentLinkFormErrors] = useState({});
  const initialSendableData = {
    user_id: paymentLinkData?.user_id || "",
    gym_id: allPaymentLinkFormValues.selectedGym?.value || "",
    // gym_id: paymentLinkData?.gym_id
    //   ? paymentLinkData.gym_id
    //   : allPaymentLinkFormValues?.selectedGym?.value
    //     ? allPaymentLinkFormValues.selectedGym.value
    //     : "",
    plan_id: allPaymentLinkFormValues?.selectedPlan?.value || "",
    addon: "",
    alternate_number: allPaymentLinkFormValues.selectedWhatsapNo || "",
    coupon: "",
    event_id: "",
    expire_date: allPaymentLinkFormValues.planExpiryDate || "",
    isWhatsapp: true,
    is_full: 1,
    is_goal: 0,
    is_partial: 0,
    is_whatsapp: true,
    order_id: "",
    order_status: "done",
    partial_details: {
      cash_amount: allPaymentLinkFormValues.partialCash || 0,
      online_amount: allPaymentLinkFormValues.partialOnline || 0,
    },
    price: allPaymentLinkFormValues.selectedPrice?.label || "",
    remark: allPaymentLinkFormValues.description || "",
    req_body: {
      // gym_id: paymentLinkData?.gym_id
      //   ? paymentLinkData.gym_id
      //   : allPaymentLinkFormValues?.selectedGym?.value
      //   ? allPaymentLinkFormValues.selectedGym.value
      //   : "",
      gym_id: allPaymentLinkFormValues.selectedGym?.value || "",
      user_id: paymentLinkData?.user_id || "",
      price: allPaymentLinkFormValues.selectedPrice?.label || "",
      trx_id: allPaymentLinkFormValues.paymentMode?.value || "",
      trx_status: "done",
      plan_id: allPaymentLinkFormValues?.selectedPlan?.value || "",
      addon: "",
      alternate_number: allPaymentLinkFormValues.selectedWhatsapNo || "",
      coupon: "",
      event_id: "",
      expire_date: allPaymentLinkFormValues.planExpiryDate || "",
      isWhatsapp: true,
      is_full: 1,
      is_goal: 0,
      is_partial: 0,
      is_whatsapp: true,
      order_id: "",
      order_status: "done",
      partial_details: {
        cash_amount: allPaymentLinkFormValues.partialCash || 0,
        online_amount: allPaymentLinkFormValues.partialOnline || 0,
      },
      remark: allPaymentLinkFormValues.description || "",
      session_id: "",
      slot_id: allPaymentLinkFormValues.selectedSlot || "",
      start_date: allPaymentLinkFormValues.selectedSubsStartDate || "",
      tax_amount: gstTableValues.taxAmount || "",
      tax_percentage: "18",
      type: allPaymentLinkFormValues.selectedPlanType?.value || "",
    },
    session_id: "",
    slot_id: allPaymentLinkFormValues.selectedSlot || "",
    start_date: allPaymentLinkFormValues.selectedSubsStartDate || "",
    tax_amount: gstTableValues.taxAmount || "",
    tax_percentage: "18",
    trx_id: allPaymentLinkFormValues.paymentMode?.value || "",
    trx_status: "done",
    type: allPaymentLinkFormValues.selectedPlanType?.value || "",
  };
  const [sendableData, setSendableData] = useState(initialSendableData);
  const [isAppliedCupon, setIsAppliedCupon] = useState(false);
  const [isSendPaymentLink, setIsSendPaymentLink] = useState(false);
  const [cashDraftId, setCashDraftId] = useState(null);
  const [showCashQR, setShowCashQR] = useState(false);
  const [pendingCashPayload, setPendingCashPayload] = useState(null);
  const initialTrainerSlotsData = {
    trainersDropdownData: [],
    trainerSlotsInfoData: [],
  };
  const [allTrainerSlotData, setAllTrainerSlotData] = useState(
    initialTrainerSlotsData
  );
  const [selectedSessionPla, setSelectedSessionPlan] = useState([]);
  const [particularGymAllInfo, setParticularGymAllInfo] = useState(null);

  // GST CALCULATION
  // const calculateCGSTSGST = (amount) => {
  //   const gstAmount = (amount * 18) / 100;
  //   const halfGst = gstAmount / 2;
  //   return halfGst.toFixed(2) || 0;
  // };

  // const calculateGST = (amount) => {
  //   const gstAmount = (amount * 18) / 100;
  //   return gstAmount.toFixed(2) || 0;
  // };

  // const calculateTotalAmount = (amount) => {
  //   const gstAmount = (amount * 18) / 100;
  //   const total = parseFloat(amount) + parseFloat(gstAmount);
  //   return total.toFixed(2) || 0;
  // };

  const calculateCGSTSGST = (amount) => {
    const preGst = amount / 1.18;
    const gstAmount = preGst * 0.18;
    const total = gstAmount / 2;
    return total.toFixed(2) || 0;
  };

  const calculatePreGST = (amount) => {
    const preGst = amount / 1.18;
    return preGst.toFixed(2) || 0;
  };

  const calculateGST = (amount) => {
    const preGst = amount / 1.18;
    const gstAmount = preGst * 0.18;
    return gstAmount.toFixed(2) || 0;
  };

  const calculateTotalAmount = (amount) => {
    const preGst = amount / 1.18;
    const gstAmount = preGst * 0.18;
    const total = preGst + gstAmount;
    return total.toFixed(2) || 0;
  };
  // --------------- GST CALCULATION ------------------

  // ALL PALNS
  const handleCreateFetchPlans = async (userData, TOKEN) => {
    try {
      const actionResult = dispatch(createFetchPlans({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status && result?.payload?.data) {
        setAllPlans({ ...allPlans, allPlansData: result.payload.data });
      } else {
        const errorMessage = result?.error?.message;
        console.log("errorMessage=> ", errorMessage);
      }
    } catch (error) {
      console.log("handleCreateFetchPlans ERROR => ", error);
    }
  };
  // ----------------- ALL PALNS ------------------

  // SELECT DESELECT
  const handleSelectPlan = (index, amount, planId, extendedDays) => {
    if (index === allPaymentLinkFormValues.selectedPlanIndex) {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        selectedPlanIndex: "",
        selectedPrice: {
          value: "",
          label: "",
        },
        selectedExtendedDays: "",
      });
    } else {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        selectedPlanIndex: index,
        selectedPrice: {
          value: planId,
          label: amount,
        },
        selectedExtendedDays: {
          label: extendedDays,
          value: extendedDays,
        },
      });
    }
  };

  const handleSelectSlot = (index, start, end, slotId) => {
    if (index === allPaymentLinkFormValues.selectedSlotIndex) {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        selectedSlotIndex: "",
        selectedSlotStartTime: "",
        selectedSlotEndTime: "",
        selectedSlot: "",
      });
    } else {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        selectedSlotIndex: index,
        selectedSlotStartTime: start,
        selectedSlotEndTime: end,
        selectedSlot: slotId,
      });
    }
  };

  const handleSelectOffer = (index, offer) => {
    setIsAppliedCupon(false);
    if (index === allPaymentLinkFormValues.selectedOfferIndex) {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        selectedOfferIndex: "",
        selectedOfferInfo: null,
        enteredCupon: "",
      });
    } else {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        selectedOfferIndex: index,
        selectedOfferInfo: offer,
      });
    }
  };

  const onChangePaymentLinkForm = (name, selectedValue) => {
    if (name === "selectedPlanType") {
      setAllPaymentLinkFormValues((prevState) => ({
        ...prevState,
        selectedPlanIndex: "",
        selectedOfferIndex: "",
        selectedPlan: "",
        selectedAddon: "",
        selectedSlotDate: "",
        selectedSlot: "",
        selectedSession: "",
        planExpiryDate: "",
        selectedPrice: "",
        [name]: selectedValue,
      }));
      setSelectedPlanAllPrice([]);
      setAllOffers(initialOfferDatas);
      setIsAppliedCupon(false);
      setAllOffers(initialOfferDatas);
    } else if (name === "selectedSession") {
      setAllPaymentLinkFormValues((prevState) => ({
        ...prevState,
        selectedTrainer: "",
        [name]: selectedValue,
      }));
    } else if (name === "selectedPlan") {
      setAllPaymentLinkFormValues((prevState) => ({
        ...prevState,
        selectedPlanIndex: "",
        selectedOfferIndex: "",
        selectedPlan: "",
        selectedAddon: "",
        selectedSlotDate: "",
        selectedSlot: "",
        selectedSession: "",
        planExpiryDate: "",
        selectedPrice: "",
        [name]: selectedValue,
      }));
      setAllOffers(initialOfferDatas);
      setIsAppliedCupon(false);
      setAllOffers(initialOfferDatas);
    } else if (name === "selectedAddon") {
      setAllPaymentLinkFormValues((prevState) => ({
        ...prevState,
        selectedPlanIndex: "",
        selectedOfferIndex: "",
        selectedPlan: "",
        selectedSlot: "",
        selectedSession: "",
        planExpiryDate: "",
        selectedPrice: "",
        selectedTrainer: "",
        [name]: selectedValue,
      }));
      setAllOffers(initialOfferDatas);
      setIsAppliedCupon(false);
      setAllOffers(initialOfferDatas);
    } else if (name === "selectedTrainer") {
      setAllPaymentLinkFormValues((prevState) => ({
        ...prevState,
        selectedSlotIndex: "",
        [name]: selectedValue,
      }));
    } else if (name === "selectedGym") {
      setAllPaymentLinkFormValues((prevState) => ({
        ...prevState,
        // selectedPlanIndex: "",
        // selectedOfferIndex: "",
        // selectedPlan: "",
        // selectedSlot: "",
        // selectedSession: "",
        // selectedPrice: "",
        // selectedTrainer: "",
        selectedAddon: "",
        [name]: selectedValue,
      }));
      setAllAddons(initialAddonsData);
    } else {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        [name]: selectedValue,
      });
    }
  };

  const onClickApplyCupon = (e) => {
    e.preventDefault();
    if (
      paymentLinkData?.user_id &&
      allPaymentLinkFormValues.selectedOfferInfo?.uid
    ) {
      dispatch(
        checkOfferValidityByUserData({
          userId: paymentLinkData.user_id,
          offerId: allPaymentLinkFormValues.selectedOfferInfo.uid,
          token: decryptedText?.token,
        })
      );
    } else if (
      allPaymentLinkFormValues.selectedPlan?.value ||
      allPaymentLinkFormValues.enteredCupon
    ) {
      const isGeneric = allOffers.allOffersData?.map(
        (offer) => offer?.is_generic === 1
      );

      if (isGeneric) {
        dispatch(
          checkOfferValidationByCodeData({
            typeId: "",
            code: allPaymentLinkFormValues.enteredCupon,
            token: decryptedText?.token,
          })
        );
      } else {
        dispatch(
          checkOfferValidationByCodeData({
            typeId: allPaymentLinkFormValues.selectedPlan?.value,
            code: allPaymentLinkFormValues.enteredCupon,
            token: decryptedText?.token,
          })
        );
      }
    } else {
      toast.error("Please Enter Valid Cupon!");
    }
  };
  // ------------------- SELECT DESELECT -------------------

  // CREATE PAYMENT LINK
  const onClickSendPaymentLink = () => {
    setPaymentLinkFormErrors(validatePaymentLinkForm(allPaymentLinkFormValues));
    setIsSendPaymentLink(true);
  };

  const handleCreatePaymentLink = async (userData, token) => {
    try {
      const actionResult = dispatch(createPaymentLink({ userData, token }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result.payload.message);
        setAllPaymentLinkFormValues(initilaPaymentLinkFormValues);
        closeModal();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleCreatePaymentLink ERROR => ", error);
    }
  };

  const handleCreatePaymentLinkAdd = async (userData, token) => {
    try {
      const actionResult = dispatch(createPaymentLinkAdd({ userData, token }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result.payload.message);
        setAllPaymentLinkFormValues(initilaPaymentLinkFormValues);
        closeModal();
      } else {
        const errorMessage = result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleCreatePaymentLinkAdd ERROR => ", error);
    }
  };

  const handleAdd = async (payload) => {
    const method = "POST";
    const endpoint = aggrementLink;
    const token = decryptedText?.token || "";

    const payloadAgreement = {
      filters: "",
      token: token,
    };

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        const isCashPayment = payload?.req_body?.trx_id === "cash" || payload?.trx_id === "cash";

        // If cash payment, show QR code for mobile verification instead of closing
        if (isCashPayment && result?.payload?.uid) {
          setCashDraftId(result.payload.uid);
          setPendingCashPayload(payload);
          setShowCashQR(true);
          toast.success("Cash request created. Scan QR to verify cash.");
        } else {
          toast.success(result?.payload?.message || "Success!");
          dispatch(fetchAgreementReportData(payloadAgreement));
          setAllPaymentLinkFormValues(initilaPaymentLinkFormValues);
          closeModal();
          callFunction();
        }
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  // Called when mobile cash verification is complete
  const handleCashVerified = async (verificationToken, verificationData) => {
    if (!pendingCashPayload) return;

    const token = decryptedText?.token || "";
    const method = "POST";
    const endpoint = aggrementLink;

    // Re-submit the payload with cash_verified flag
    const verifiedPayload = {
      ...pendingCashPayload,
      cash_verified: true,
      cash_verification_token: verificationToken,
      req_body: {
        ...pendingCashPayload.req_body,
        cash_verified: true,
        cash_verification_token: verificationToken,
      },
    };

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload: verifiedPayload, token })
      );

      if (result?.payload?.status) {
        toast.success("Subscription created successfully!");
        const payloadAgreement = { filters: "", token };
        dispatch(fetchAgreementReportData(payloadAgreement));
        setAllPaymentLinkFormValues(initilaPaymentLinkFormValues);
        setShowCashQR(false);
        setCashDraftId(null);
        setPendingCashPayload(null);
        closeModal();
        callFunction();
      } else {
        toast.error(result?.payload?.message || "Failed to create subscription");
      }
    } catch (error) {
      console.error("Error creating verified cash subscription:", error);
    }
  };
  // ------------------ CREATE PAYMENT LINK -------------------

  // GEETING DATAS
  function getSourceName() {
    const filter = {
      page: 1,
      limit: 200,
    };

    dispatch(
      fetchSourceNameData({
        filters: filter,
        token: decryptedText?.token,
      })
    );
  }

  function getAllAdmins(gymId) {
    dispatch(
      fetchIndividualTypeData({
        token: decryptedText?.token,
        qps: `account_type=receptionist,trainer&gym_id=${gymId}`,
        pageNo: 1,
        limit: 100,
      })
    );
  }
  // ------------------------- GEETING DATAS --------------------------

  useEffect(() => {
    setAllPaymentLinkFormValues((prevs) => ({
      ...prevs,
      selectedGym: {
        label: paymentLinkData?.gym_name,
        value: paymentLinkData?.gym_id,
      },
    }));
  }, [paymentLinkData]);

  // console.log("paymentLinkData=> ", paymentLinkData);

  useEffect(() => {
    if (allPaymentLinkFormValues.selectedPlanType?.value === "regular") {
      handleCreateFetchPlans(
        {
          gym_id:
            allPaymentLinkFormValues.selectedGym?.value ||
            paymentLinkData?.gym_id ||
            sendableData.gym_id,
        },
        decryptedText?.token
      );
    }

    if (
      allPaymentLinkFormValues.selectedPlanType?.value === "addon" ||
      allPaymentLinkFormValues.selectedPlanType?.value === "addon_pt"
    ) {
      dispatch(
        fetchAllAddonsByGymData({
          gymId:
            allPaymentLinkFormValues.selectedGym?.value ||
            paymentLinkData?.gym_id ||
            sendableData.gym_id,
          isPT:
            allPaymentLinkFormValues.selectedPlanType?.value === "addon_pt"
              ? 1
              : 0,
          token: decryptedText?.token,
        })
      );
    }
  }, [
    allPaymentLinkFormValues.selectedGym?.value,
    paymentLinkData?.gym_id,
    allPaymentLinkFormValues.selectedPlanType?.value,
  ]);

  useEffect(() => {
    if (
      (allPaymentLinkFormValues.selectedPlan?.value ||
        allPaymentLinkFormValues?.selectedAddon?.value) &&
      allPaymentLinkFormValues.selectedPrice?.label
    ) {
      dispatch(
        fetchAllOffersByTypeIdData({
          typeId:
            allPaymentLinkFormValues.selectedPlan?.value ||
            allPaymentLinkFormValues?.selectedAddon?.value,
          sellingPrice: allPaymentLinkFormValues.selectedPrice?.label,
          token: decryptedText?.token,
        })
      );
    }
  }, [
    allPaymentLinkFormValues.selectedPlan?.value,
    allPaymentLinkFormValues?.selectedAddon?.value,
    allPaymentLinkFormValues.selectedPrice,
  ]);

  useEffect(() => {
    getSourceName();
  }, []);

  useEffect(() => {
    getAllAdmins(allPaymentLinkFormValues.selectedGym?.value);
  }, [allPaymentLinkFormValues.selectedGym]);

  useEffect(() => {
    if (
      offerValidityCheckByUser?.status &&
      offerValidityCheckByUser?.message === "Offer is valid"
    ) {
      setIsAppliedCupon(true);
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        discountableValue: allPaymentLinkFormValues.selectedOfferInfo?.value,
      });
    } else if (
      !offerValidityCheckByUser?.status &&
      offerValidityCheckByUser?.message
    ) {
      toast.error(
        offerValidityCheckByUser?.message
          ? offerValidityCheckByUser.message
          : "User Already Consumed!"
      );
    } else if (
      offerValidityCheckByUser?.status &&
      offerValidityCheckByUser?.data &&
      offerValidityCheckByUser?.data?.length > 0
    ) {
      const desiredOffer = offerValidityCheckByUser.data?.[0];

      if (desiredOffer) {
      }

      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        discountableValue: desiredOffer?.value,
        selectedOfferInfo: desiredOffer,
      });
      setIsAppliedCupon(true);
    }
  }, [offerValidityCheckByUser]);

  useEffect(() => {
    if (
      !allPaymentLinkFormValues.selectedOfferInfo?.uid &&
      !allPaymentLinkFormValues.enteredCupon
    ) {
      setIsAppliedCupon(false);
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        discountableValue: "",
        selectedOfferInfo: null,
      });
    }
  }, [
    allPaymentLinkFormValues.selectedOfferInfo?.uid,
    allPaymentLinkFormValues.enteredCupon,
  ]);

  useEffect(() => {
    if (allOffersByTypeIdData?.status && allOffersByTypeIdData?.data) {
      const currentDate = new Date();

      const allPublicOffersFilter = allOffersByTypeIdData.data?.filter(
        (offer) => {
          const validationDate = parse(
            offer?.validity,
            "dd-MM-yyyy",
            new Date()
          );
          return offer?.is_public === 1 && validationDate >= currentDate;
        }
      );

      const allPrivateOffersFilter = allOffersByTypeIdData.data?.filter(
        (offer) => {
          const validationDate = parse(
            offer?.validity,
            "dd-MM-yyyy",
            new Date()
          );
          return offer?.is_public === 0 && validationDate >= currentDate;
        }
      );

      setAllOffers({
        ...allOffers,
        allOffersData: allOffersByTypeIdData.data,
        allPublicOffers: allPublicOffersFilter,
        allPrivateOffers: allPrivateOffersFilter,
      });
    } else {
      setAllOffers({
        ...allOffers,
        allOffersData: [],
        allPublicOffers: [],
        allPrivateOffers: [],
      });
    }
  }, [allOffersByTypeIdData]);

  useEffect(() => {
    if (
      (allPaymentLinkFormValues.selectedPlanType?.value !== "regular" &&
        allPlans.extendableDaysData?.length > 0) ||
      (allPaymentLinkFormValues.selectedPlanType?.value !== "regular" &&
        allPaymentLinkFormValues.selectedExtendedDays)
    ) {
      setAllPlans((prevAllPlans) => ({
        ...prevAllPlans,
        extendableDaysData: [],
      }));
      setAllPaymentLinkFormValues((prevAllPlans) => ({
        ...prevAllPlans,
        selectedExtendedDays: "",
      }));
    } else if (
      allPaymentLinkFormValues.selectedPlanType?.value === "regular" &&
      !allPaymentLinkFormValues.selectedPlan
    ) {
      setAllPlans((prevAllPlans) => ({
        ...prevAllPlans,
        extendableDaysData: [],
      }));
      setAllPaymentLinkFormValues((prevAllPlans) => ({
        ...prevAllPlans,
        selectedExtendedDays: "",
      }));
    }
  }, [
    allPaymentLinkFormValues.selectedPlanType?.value,
    allPlans.extendableDaysData?.length,
    allPaymentLinkFormValues.selectedExtendedDays,
    allPaymentLinkFormValues.selectedPlan,
  ]);

  useEffect(() => {
    if (
      allPlans?.allPlansData?.length > 0 &&
      allPaymentLinkFormValues.selectedPlanType?.value === "regular"
    ) {
      const selectedPlanIfo = allPlans.allPlansData?.filter(
        (plan) => plan.plan_uid === allPaymentLinkFormValues.selectedPlan?.value
      );

      let extendedDays = [];

      if (selectedPlanIfo?.length > 0) {
        const extendedDaysObj = JSON.parse(
          selectedPlanIfo?.[0]?.extendable_days
        );
        extendedDays = extendedDaysObj?.map((ex) => ({
          label: ex?.days,
          value: ex?.days,
        }));
      }

      const allPlansDropdownDataFind = allPlans.allPlansData.map((plan) => {
        return {
          label: `${plan.plan_name}/${plan.duration}Days`,
          value: plan.plan_uid,
        };
      });

      if (
        allPaymentLinkFormValues.selectedPlan?.value &&
        selectedPlanIfo?.[0]?.price_details?.length > 0
      ) {
        setSelectedPlanAllPrice(selectedPlanIfo?.[0]?.price_details);
      } else {
        setSelectedPlanAllPrice([]);
        setAllPaymentLinkFormValues({
          ...allPaymentLinkFormValues,
          selectedPlanIndex: "",
        });
      }

      setAllPlans({
        ...allPlans,
        allPlansDropdownData: allPlansDropdownDataFind,
        selectedPlanInfo: selectedPlanIfo,
        extendableDaysData: extendedDays,
      });

      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        finalBaseAmount: selectedPlanIfo?.[0]?.base_price || 0,
        planDuration: selectedPlanIfo?.[0]?.duration || 0,
      });
    } else {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        finalBaseAmount: 0,
        planDuration: 0,
      });
    }
  }, [
    allPlans.allPlansData,
    allPaymentLinkFormValues.selectedPlan?.value,
    allPaymentLinkFormValues.selectedPlanType?.value,
  ]);

  useEffect(() => {
    if (
      (allPaymentLinkFormValues.selectedPlanType?.value !== "regular" &&
        allPlans.extendableDaysData?.length > 0) ||
      (allPaymentLinkFormValues.selectedPlanType?.value !== "regular" &&
        allPaymentLinkFormValues.selectedExtendedDays)
    ) {
      setAllPlans((prevAllPlans) => ({
        ...prevAllPlans,
        extendableDaysData: [],
      }));
      setAllPaymentLinkFormValues((prevAllPlans) => ({
        ...prevAllPlans,
        selectedExtendedDays: "",
      }));
    } else if (
      allPaymentLinkFormValues.selectedPlanType?.value === "regular" &&
      !allPaymentLinkFormValues.selectedPlan
    ) {
      setAllPlans((prevAllPlans) => ({
        ...prevAllPlans,
        extendableDaysData: [],
      }));
      setAllPaymentLinkFormValues((prevAllPlans) => ({
        ...prevAllPlans,
        selectedExtendedDays: "",
      }));
    }
  }, [
    allPaymentLinkFormValues.selectedPlanType,
    // allPlans.extendableDaysData,
    allPaymentLinkFormValues.selectedPlan,
  ]);

  useEffect(() => {
    if (allAddonSlots?.status && allAddonSlots?.data?.length > 0) {
      const allAddonsSlotsDropdownDataFind = allAddonSlots.data.map((slot) => {
        const startTime = moment(slot?.start_time, "HH:mm:ss")
          .tz("Asia/Kolkata")
          .format("hh:mm A");
        const endTime = moment(slot?.end_time, "HH:mm:ss")
          .tz("Asia/Kolkata")
          .format("hh:mm A");
        return {
          label: `${startTime} - ${endTime}`,
          value: slot.uid,
        };
      });
      setAllAddons({
        ...allAddons,
        allSlotsData: allAddonSlots.data,
        allSlotsDropdownData: allAddonsSlotsDropdownDataFind,
      });
    } else {
      setAllAddons((prevs) => ({
        ...prevs,
        allSlotsData: [],
        allSlotsDropdownData: [],
      }));
    }
  }, [allAddonSlots]);

  useEffect(() => {
    if (allAddonSessions?.status && allAddonSessions?.data?.length > 0) {
      const allAddonsSessionsDropdownDataFind = allAddonSessions.data.map(
        (addon) => {
          return {
            label:
              `${addon?.n_session} Sessions for ${addon?.duration} Day(s)` ||
              "",
            value: addon?.uid || "",
            info: addon,
          };
        }
      );

      setAllAddons({
        ...allAddons,
        allSessionsData: allAddonSessions.data,
        allSessionsDropdownData: allAddonsSessionsDropdownDataFind,
      });
    } else {
      setAllAddons({
        ...allAddons,
        allSessionsData: [],
        allSessionsDropdownData: [],
      });
    }
  }, [allAddonSessions, allPaymentLinkFormValues.selectedPlanType?.value]);

  useEffect(() => {
    if (allPaymentLinkFormValues.selectedSession?.value) {
      const priceDetailsArray = allAddonSessions?.data?.filter(
        (addon) =>
          addon?.uid === allPaymentLinkFormValues.selectedSession?.value
      );

      setSelectedSessionPlan(priceDetailsArray);

      if (
        (allPaymentLinkFormValues.selectedPlanType?.value === "addon" ||
          allPaymentLinkFormValues.selectedPlanType?.value === "addon_pt") &&
        allPaymentLinkFormValues.selectedAddon?.value &&
        priceDetailsArray?.[0]?.price_details?.length > 0
      ) {
        setSelectedPlanAllPrice(priceDetailsArray?.[0]?.price_details);
      } else {
        setSelectedPlanAllPrice([]);
        setAllPaymentLinkFormValues({
          ...allPaymentLinkFormValues,
          selectedPlanIndex: "",
        });
      }
    } else {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        finalBaseAmount: "",
        planDuration: "",
        selectedPlanIndex: "",
        trainer_exp_lvl: "",
      });
      setSelectedPlanAllPrice([]);
    }
  }, [
    allPaymentLinkFormValues.selectedPlanType?.value,
    allPaymentLinkFormValues.selectedSession?.value,
  ]);

  useEffect(() => {
    if (selectedSessionPla?.length > 0) {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        finalBaseAmount: selectedSessionPla?.[0]?.price || 0,
        planDuration: selectedSessionPla?.[0]?.duration || 0,
        trainer_exp_lvl: selectedSessionPla?.[0]?.trainer_exp_lvl || "",
      });
    }
  }, [selectedSessionPla]);

  useEffect(() => {
    if (allPaymentLinkFormValues.trainer_exp_lvl) {
      const selectedGymQueryParam = !isAdmin
        ? `&gym_id=${
            decryptedText?.gym_id ||
            decryptedText?.user_id ||
            decryptedText?.uid
          }`
        : allPaymentLinkFormValues?.selectedGym?.value
        ? `&gym_id=${allPaymentLinkFormValues.selectedGym.value}`
        : "";
      const expLvlQueryParam = `&trainer_exp_lvl=${allPaymentLinkFormValues.trainer_exp_lvl}`;
      const queryParametersForOnline = `${selectedGymQueryParam}${expLvlQueryParam}`;

      if (expLvlQueryParam && !isComingPT) {
        dispatch(
          fetchAllTrainersByExpLvlData({
            queryParameters: queryParametersForOnline,
            token: decryptedText?.token,
          })
        );
      } else if (isComingPT) {
        dispatch(
          fetchPTTrainersData({
            gymId: allPaymentLinkFormValues.selectedGym?.value || "",
            token: decryptedText?.token,
          })
        );
      }
    }
  }, [
    allPaymentLinkFormValues.trainer_exp_lvl,
    allPaymentLinkFormValues.selectedGym?.value,
    selectedSessionPla,
  ]);

  // TRAINER EXP LEVEL
  useEffect(() => {
    if (
      !isComingPT &&
      allTrainerByExpLvlData?.status &&
      allTrainerByExpLvlData?.data
    ) {
      const trainers = allTrainerByExpLvlData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainerSlotData((prevAllTrainerSlotData) => ({
        ...prevAllTrainerSlotData,
        trainersDropdownData: trainers,
      }));
      // setTrainersDropdownData(trainers);
    } else {
      // setAllTrainerSlotData(initialTrainerSlotsData);
      // setTrainersDropdownData([]);
    }

    if (
      isComingPT &&
      allPTTrainersData?.status &&
      allPTTrainersData?.data?.length > 0
    ) {
      const trainers = allPTTrainersData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainerSlotData((prevAllTrainerSlotData) => ({
        ...prevAllTrainerSlotData,
        trainersDropdownData: trainers,
      }));
      // setTrainersDropdownData(trainers);
    } else {
      // setAllTrainerSlotData(initialTrainerSlotsData);
      // setTrainersDropdownData([]);
    }
  }, [allTrainerByExpLvlData, allPTTrainersData, isComingPT]);
  // ----------- TRAINER EXP LEVEL ------------

  // TRAINER SLOTS
  useEffect(() => {
    if (allPaymentLinkFormValues.selectedTrainer?.value) {
      dispatch(
        fetchAllTrainersSlotsData({
          trainerSlot: allPaymentLinkFormValues.selectedTrainer.value,
          token: decryptedText?.token,
        })
      );
    }
  }, [allPaymentLinkFormValues.selectedTrainer?.value]);

  useEffect(() => {
    if (trainerSlotDetails?.data) {
      const selectedTrainerData = trainerSlotDetails.data?.slot_details || null;

      setAllTrainerSlotData({
        ...allTrainerSlotData,
        trainerSlotsInfoData: selectedTrainerData ? [selectedTrainerData] : [],
      });
    } else {
      setAllTrainerSlotData({
        ...allTrainerSlotData,
        trainerSlotsInfoData: [],
      });
    }

    if (!allPaymentLinkFormValues.selectedTrainer) {
      setAllPaymentLinkFormValues((prevState) => ({
        ...prevState,
        selectedSlotIndex: "",
      }));
      setAllTrainerSlotData((prevState) => ({
        ...prevState,
        trainerSlotsInfoData: [],
      }));
    }
  }, [trainerSlotDetails, allPaymentLinkFormValues.selectedTrainer?.value]);
  // -------------- TRAINER SLOTS ----------------

  useEffect(() => {
    if (allAddonsByGymData?.status && allAddonsByGymData?.data?.length > 0) {
      const allAddonsDropdownDataFind = allAddonsByGymData.data.map((addon) => {
        return {
          label: `${addon.name} / ${addon?.is_pt === "1" ? "PT" : "Not PT"}`,
          value: addon.uid,
        };
      });
      setAllAddons({
        ...allAddons,
        allAddonsData: allAddonsByGymData.data,
        allAddonsDropdownData: allAddonsDropdownDataFind,
      });
    } else {
      setAllAddons((prevs) => ({
        ...prevs,
        allAddonsData: [],
        allAddonsDropdownData: [],
      }));
    }
  }, [allAddonsByGymData]);

  useEffect(() => {
    if (allPaymentLinkFormValues.selectedAddon?.value) {
      dispatch(
        fetchAllAddonSessionsData({
          addonId: allPaymentLinkFormValues.selectedAddon.value,
          token: decryptedText?.token,
        })
      );
    }

    if (
      allPaymentLinkFormValues.selectedAddon?.value &&
      allPaymentLinkFormValues.selectedSlotDate
    ) {
      dispatch(
        fetchAllAddonSlotsData({
          addonId: allPaymentLinkFormValues.selectedAddon.value,
          slotDate:
            (allPaymentLinkFormValues.selectedSlotDate &&
              moment(allPaymentLinkFormValues.selectedSlotDate)
                .tz("Asia/Kolkata")
                .format("DD-MM-YYYY")) ||
            "",
          token: decryptedText?.token,
        })
      );
    }
  }, [
    allPaymentLinkFormValues.selectedAddon?.value,
    allPaymentLinkFormValues.selectedSlotDate,
  ]);

  useEffect(() => {
    if (allPaymentLinkFormValues.selectedExtendedDays?.value) {
      let subsStartDate, subsEndDate;
      if (
        allPaymentLinkFormValues.selectedPlanType?.value === "regular" &&
        allPlans.selectedPlanInfo?.[0]?.duration
      ) {
        subsStartDate = allPaymentLinkFormValues.selectedSubsStartDate;
        subsEndDate = moment(subsStartDate, "YYYY-MM-DD")
          .tz("Asia/Kolkata")
          .add(parseInt(allPlans.selectedPlanInfo[0].duration), "days")
          .format("YYYY-MM-DD");
      } else if (
        (allPaymentLinkFormValues.selectedPlanType?.value === "addon" ||
          allPaymentLinkFormValues.selectedPlanType?.value === "addon_pt") &&
        allPaymentLinkFormValues?.planDuration
      ) {
        subsStartDate = allPaymentLinkFormValues.selectedSubsStartDate;
        subsEndDate = moment(subsStartDate, "YYYY-MM-DD")
          .tz("Asia/Kolkata")
          .add(parseInt(allPaymentLinkFormValues?.planDuration), "days")
          .format("YYYY-MM-DD");
      }

      let expiryDate = moment(subsEndDate, "YYYY-MM-DD")
        .tz("Asia/Kolkata")
        .add(
          parseInt(allPaymentLinkFormValues.selectedExtendedDays?.value) || 0,
          "days"
        )
        .format("YYYY-MM-DD");

      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        planExpiryDate: moment(expiryDate, "YYYY-MM-DD")
          .tz("Asia/Kolkata")
          .format("DD-MM-YYYY"),
      });
    } else if (
      allPlans.selectedPlanInfo?.[0]?.duration ||
      allPaymentLinkFormValues?.planDuration
    ) {
      let subsStartDate, subsEndDate;
      if (
        // allPaymentLinkFormValues.selectedPlanType?.value === "regular" &&
        allPlans.selectedPlanInfo?.[0]?.duration
      ) {
        subsStartDate = allPaymentLinkFormValues.selectedSubsStartDate;
        subsEndDate = moment(subsStartDate, "YYYY-MM-DD")
          .tz("Asia/Kolkata")
          .add(parseInt(allPlans.selectedPlanInfo[0].duration), "days")
          .format("YYYY-MM-DD");
      } else if (
        // allPaymentLinkFormValues.selectedPlanType?.value === "addon" &&
        allPaymentLinkFormValues?.planDuration
      ) {
        subsStartDate = allPaymentLinkFormValues.selectedSubsStartDate;
        subsEndDate = moment(subsStartDate, "YYYY-MM-DD")
          .tz("Asia/Kolkata")
          .add(parseInt(allPaymentLinkFormValues.planDuration), "days")
          .format("YYYY-MM-DD");
      }

      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        planExpiryDate: moment(subsEndDate, "YYYY-MM-DD")
          .tz("Asia/Kolkata")
          .format("DD-MM-YYYY"),
      });
    } else {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        planExpiryDate: null,
      });
    }
  }, [
    allPaymentLinkFormValues.selectedExtendedDays,
    allPaymentLinkFormValues.selectedSubsStartDate,
    allPaymentLinkFormValues.selectedSession?.value,
    allPaymentLinkFormValues?.planDuration,
  ]);

  useEffect(() => {
    if (allPaymentLinkFormValues.selectedPrice?.label) {
      let sendablePrice;
      if (
        allPaymentLinkFormValues.selectedOfferInfo?.type &&
        allPaymentLinkFormValues.selectedOfferInfo?.type === "flat"
      ) {
        sendablePrice =
          allPaymentLinkFormValues.selectedPrice?.label -
          allPaymentLinkFormValues.discountableValue;
      } else if (allPaymentLinkFormValues.selectedOfferInfo?.type) {
        const discount =
          (allPaymentLinkFormValues.selectedPrice?.label *
            allPaymentLinkFormValues.discountableValue) /
          100;
        sendablePrice =
          allPaymentLinkFormValues.selectedPrice?.label - discount;
      }

      const amount = sendablePrice
        ? sendablePrice
        : allPaymentLinkFormValues.selectedPrice?.label;
      // const taxableAmount = 0;
      const taxableAmount = calculatePreGST(amount);
      const sgst = calculateCGSTSGST(amount);
      const cgst = calculateCGSTSGST(amount);
      const totalAmount = calculateTotalAmount(amount);
      const taxAmount = calculateGST(amount);

      setGstTableValues({
        ...gstTableValues,
        amount,
        taxableAmount,
        sgst,
        cgst,
        totalAmount,
        taxAmount,
      });
    } else {
      setGstTableValues(initialGstTableValues);
    }
  }, [
    allPaymentLinkFormValues.selectedPrice?.label,
    allPaymentLinkFormValues.discountableValue,
  ]);

  useEffect(() => {
    if (allPaymentLinkFormValues.selectedOfferInfo) {
      setAllPaymentLinkFormValues({
        ...allPaymentLinkFormValues,
        enteredCupon: allPaymentLinkFormValues.selectedOfferInfo?.name,
        // discountableValue: allPaymentLinkFormValues.selectedOfferInfo?.value,
      });
    }
  }, [allPaymentLinkFormValues.selectedOfferInfo]);

  useEffect(() => {
    if (Object.keys(paymentLinkFormErrors).length === 0 && isSendPaymentLink) {
      let sendablePrice;
      if (allPaymentLinkFormValues.selectedOfferInfo) {
        if (
          allPaymentLinkFormValues.selectedOfferInfo?.type &&
          allPaymentLinkFormValues.selectedOfferInfo?.type === "flat"
        ) {
          sendablePrice =
            allPaymentLinkFormValues.selectedPrice?.label -
            allPaymentLinkFormValues.discountableValue;
        } else if (allPaymentLinkFormValues.selectedOfferInfo?.type) {
          const discount =
            (allPaymentLinkFormValues.selectedPrice?.label *
              allPaymentLinkFormValues.discountableValue) /
            100;
          sendablePrice =
            allPaymentLinkFormValues.selectedPrice?.label - discount;
        }
      }

      const userData = {
        is_web: 1,
        user_id: paymentLinkData?.user_id || "",
        gym_id: allPaymentLinkFormValues.selectedGym?.value || "",
        // gym_id: paymentLinkData?.gym_id
        //   ? paymentLinkData.gym_id
        //   : allPaymentLinkFormValues?.selectedGym?.value
        //   ? allPaymentLinkFormValues.selectedGym.value
        //   : "",
        type: allPaymentLinkFormValues.selectedPlanType?.value || "",
        plan_id:
          allPaymentLinkFormValues?.selectedPlan?.value ||
          allPaymentLinkFormValues.selectedAddon?.value ||
          "",
        price: sendablePrice
          ? sendablePrice
          : allPaymentLinkFormValues.selectedPrice?.label || "",
        is_partial: 0,
        lead_source: allPaymentLinkFormValues.selSourceName?.value || "",
        is_trial:
          allPaymentLinkFormValues.selectedSession?.info &&
          allPaymentLinkFormValues.selectedSession?.info?.is_trial
            ? 1
            : 0,
        requested_by: allPaymentLinkFormValues.selectedRequestedBy?.value || "",
        extend_days: allPaymentLinkFormValues.selectedExtendedDays?.value || "",

        req_body: {
          user_id: paymentLinkData?.user_id || "",
          gym_id: allPaymentLinkFormValues.selectedGym?.value || "",
          // gym_id: paymentLinkData?.gym_id
          //   ? paymentLinkData.gym_id
          //   : allPaymentLinkFormValues?.selectedGym?.value
          //   ? allPaymentLinkFormValues.selectedGym.value
          //   : "",
          plan_id: allPaymentLinkFormValues?.selectedPlan?.value || "",
          addon: allPaymentLinkFormValues.selectedAddon?.value || "",
          alternate_number: allPaymentLinkFormValues.selectedWhatsapNo || "",
          coupon: "",
          event_id: "",
          expire_date: allPaymentLinkFormValues.planExpiryDate || "",
          isWhatsapp: true,
          is_full:
            allPaymentLinkFormValues.paymentMode?.value !== "partial" ? 1 : 0,
          is_goal: 0,
          is_partial: 0,
          is_whatsapp: true,
          order_id: "",
          order_status:
            allPaymentLinkFormValues.paymentMode?.value === "cash"
              ? "done"
              : "",
          partial_details: {
            cash_amount: allPaymentLinkFormValues.partialCash || 0,
            online_amount: allPaymentLinkFormValues.partialOnline || 0,
          },
          price: sendablePrice
            ? sendablePrice
            : allPaymentLinkFormValues.selectedPrice?.label || "",
          remark: allPaymentLinkFormValues.description || "",
          session_id: allPaymentLinkFormValues.selectedSession?.value || "",
          slot_id: allPaymentLinkFormValues.selectedSlot || "",
          start_date:
            moment(allPaymentLinkFormValues.selectedSubsStartDate, "YYYY-MM-DD")
              .tz("Asia/Kolkata")
              .format("DD-MM-YYYY") ||
            "" ||
            "",
          tax_amount: gstTableValues.taxAmount || "",
          tax_percentage: "18",
          trx_id:
            allPaymentLinkFormValues.paymentMode?.value === "cash"
              ? allPaymentLinkFormValues.paymentMode?.value
              : "",
          trx_status:
            allPaymentLinkFormValues.paymentMode?.value === "cash"
              ? "done"
              : "",
          type: allPaymentLinkFormValues.selectedPlanType?.value || "",
          trainer_id: allPaymentLinkFormValues.selectedTrainer?.value || "",
          start_time: allPaymentLinkFormValues.selectedSlotStartTime || "",
          end_time: allPaymentLinkFormValues.selectedSlotEndTime || "",
          lead_source: allPaymentLinkFormValues.selSourceName?.value || "",
          is_trial:
            allPaymentLinkFormValues.selectedSession?.info &&
            allPaymentLinkFormValues.selectedSession?.info?.is_trial
              ? 1
              : 0,
          requested_by:
            allPaymentLinkFormValues.selectedRequestedBy?.value || "",

          req_body: {
            user_id: paymentLinkData?.user_id || "",
            gym_id: allPaymentLinkFormValues.selectedGym?.value || "",
            // gym_id: paymentLinkData?.gym_id
            //   ? paymentLinkData.gym_id
            //   : allPaymentLinkFormValues?.selectedGym?.value
            //   ? allPaymentLinkFormValues.selectedGym.value
            //   : "",
            plan_id: allPaymentLinkFormValues?.selectedPlan?.value || "",
            addon: allPaymentLinkFormValues.selectedAddon?.value || "",
            alternate_number: allPaymentLinkFormValues.selectedWhatsapNo || "",
            coupon: "",
            event_id: "",
            expire_date: allPaymentLinkFormValues.planExpiryDate || "",
            isWhatsapp: true,
            is_full:
              allPaymentLinkFormValues.paymentMode?.value !== "partial" ? 1 : 0,
            is_goal: 0,
            is_partial: 0,
            is_whatsapp: true,
            order_id: "",
            order_status:
              allPaymentLinkFormValues.paymentMode?.value === "cash"
                ? "done"
                : "",
            partial_details: {
              cash_amount: allPaymentLinkFormValues.partialCash || 0,
              online_amount: allPaymentLinkFormValues.partialOnline || 0,
            },
            price: sendablePrice
              ? sendablePrice
              : allPaymentLinkFormValues.selectedPrice?.label || "",
            remark: allPaymentLinkFormValues.description || "",
            session_id: allPaymentLinkFormValues.selectedSession?.value || "",
            slot_id: allPaymentLinkFormValues.selectedSlot || "",
            start_date:
              moment(
                allPaymentLinkFormValues.selectedSubsStartDate,
                "YYYY-MM-DD"
              )
                .tz("Asia/Kolkata")
                .format("DD-MM-YYYY") ||
              "" ||
              "",
            tax_amount: gstTableValues.taxAmount || "",
            tax_percentage: "18",
            trx_id:
              allPaymentLinkFormValues.paymentMode?.value === "cash"
                ? allPaymentLinkFormValues.paymentMode?.value
                : "",
            trx_status:
              allPaymentLinkFormValues.paymentMode?.value === "cash"
                ? "done"
                : "",
            type: allPaymentLinkFormValues.selectedPlanType?.value || "",
            trainer_id: allPaymentLinkFormValues.selectedTrainer?.value || "",
            start_time: allPaymentLinkFormValues.selectedSlotStartTime || "",
            end_time: allPaymentLinkFormValues.selectedSlotEndTime || "",
            lead_source: allPaymentLinkFormValues.selSourceName?.value || "",
            is_trial:
              allPaymentLinkFormValues.selectedSession?.info &&
              allPaymentLinkFormValues.selectedSession?.info?.is_trial
                ? 1
                : 0,
            requested_by:
              allPaymentLinkFormValues.selectedRequestedBy?.value || "",
            extend_days:
              allPaymentLinkFormValues.selectedExtendedDays?.value || "",
          },
        },
      };

      const userDataOLD = {
        user_id: paymentLinkData?.user_id || "",
        gym_id: allPaymentLinkFormValues.selectedGym?.value || "",
        // gym_id: paymentLinkData?.gym_id
        //   ? paymentLinkData.gym_id
        //   : allPaymentLinkFormValues?.selectedGym?.value
        //   ? allPaymentLinkFormValues.selectedGym.value
        //   : "",
        plan_id: allPaymentLinkFormValues?.selectedPlan?.value || "",
        addon: allPaymentLinkFormValues.selectedAddon?.value || "",
        alternate_number: allPaymentLinkFormValues.selectedWhatsapNo || "",
        coupon: "",
        event_id: "",
        expire_date: allPaymentLinkFormValues.planExpiryDate || "",
        isWhatsapp: true,
        is_full:
          allPaymentLinkFormValues.paymentMode?.value !== "partial" ? 1 : 0,
        is_goal: 0,
        is_partial: 0,
        is_whatsapp: true,
        order_id: "",
        order_status:
          allPaymentLinkFormValues.paymentMode?.value === "cash" ? "done" : "",
        partial_details: {
          cash_amount: allPaymentLinkFormValues.partialCash || 0,
          online_amount: allPaymentLinkFormValues.partialOnline || 0,
        },
        price: sendablePrice
          ? sendablePrice
          : allPaymentLinkFormValues.selectedPrice?.label || "",
        remark: allPaymentLinkFormValues.description || "",
        session_id: allPaymentLinkFormValues.selectedSession?.value || "",
        slot_id: allPaymentLinkFormValues.selectedSlot || "",
        start_date:
          moment(allPaymentLinkFormValues.selectedSubsStartDate, "YYYY-MM-DD")
            .tz("Asia/Kolkata")
            .format("DD-MM-YYYY") ||
          "" ||
          "",
        tax_amount: gstTableValues.taxAmount || "",
        tax_percentage: "18",
        trx_id:
          allPaymentLinkFormValues.paymentMode?.value === "cash"
            ? allPaymentLinkFormValues.paymentMode?.value
            : "",
        trx_status:
          allPaymentLinkFormValues.paymentMode?.value === "cash" ? "done" : "",
        type: allPaymentLinkFormValues.selectedPlanType?.value || "",
        trainer_id: allPaymentLinkFormValues.selectedTrainer?.value || "",
        start_time: allPaymentLinkFormValues.selectedSlotStartTime || "",
        end_time: allPaymentLinkFormValues.selectedSlotEndTime || "",
        lead_source: allPaymentLinkFormValues.selSourceName?.value || "",
        req_body: {
          user_id: paymentLinkData?.user_id || "",
          gym_id: allPaymentLinkFormValues.selectedGym?.value || "",
          // gym_id: paymentLinkData?.gym_id
          //   ? paymentLinkData.gym_id
          //   : allPaymentLinkFormValues?.selectedGym?.value
          //   ? allPaymentLinkFormValues.selectedGym.value
          //   : "",
          plan_id: allPaymentLinkFormValues?.selectedPlan?.value || "",
          addon: allPaymentLinkFormValues.selectedAddon?.value || "",
          alternate_number: allPaymentLinkFormValues.selectedWhatsapNo || "",
          coupon: "",
          event_id: "",
          expire_date: allPaymentLinkFormValues.planExpiryDate || "",
          isWhatsapp: true,
          is_full:
            allPaymentLinkFormValues.paymentMode?.value !== "partial" ? 1 : 0,
          is_goal: 0,
          is_partial: 0,
          is_whatsapp: true,
          order_id: "",
          order_status:
            allPaymentLinkFormValues.paymentMode?.value === "cash"
              ? "done"
              : "",
          partial_details: {
            cash_amount: allPaymentLinkFormValues.partialCash || 0,
            online_amount: allPaymentLinkFormValues.partialOnline || 0,
          },
          price: sendablePrice
            ? sendablePrice
            : allPaymentLinkFormValues.selectedPrice?.label || "",
          remark: allPaymentLinkFormValues.description || "",
          session_id: allPaymentLinkFormValues.selectedSession?.value || "",
          slot_id: allPaymentLinkFormValues.selectedSlot || "",
          start_date:
            moment(allPaymentLinkFormValues.selectedSubsStartDate, "YYYY-MM-DD")
              .tz("Asia/Kolkata")
              .format("DD-MM-YYYY") ||
            "" ||
            "",
          tax_amount: gstTableValues.taxAmount || "",
          tax_percentage: "18",
          trx_id:
            allPaymentLinkFormValues.paymentMode?.value === "cash"
              ? allPaymentLinkFormValues.paymentMode?.value
              : "",
          trx_status:
            allPaymentLinkFormValues.paymentMode?.value === "cash"
              ? "done"
              : "",
          type: allPaymentLinkFormValues.selectedPlanType?.value || "",
          trainer_id: allPaymentLinkFormValues.selectedTrainer?.value || "",
          start_time: allPaymentLinkFormValues.selectedSlotStartTime || "",
          end_time: allPaymentLinkFormValues.selectedSlotEndTime || "",
          lead_source: allPaymentLinkFormValues.selSourceName?.value || "",
        },
      };

      // if (allPaymentLinkFormValues.paymentMode?.value === "cash") {
      //   handleCreatePaymentLinkAdd(userDataOLD, decryptedText?.token);
      // } else {
      //   handleCreatePaymentLink(userDataOLD, decryptedText?.token);
      // }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `An agreement link will be sent to the customer for approval first. Once the approval is done, a payment link will be sent to the customer. For cash payments, a cash approval link will be sent to the front desk or the currently logged-in user.`,
        "No, Edit Form!",
        "Yes, proceed!"
      );

      setIsSendPaymentLink(false);
    } else {
      setIsSendPaymentLink(false);
    }
  }, [isSendPaymentLink]);

  useEffect(() => {
    dispatch(fetchGymData(decryptedText?.token));
  }, []);

  useEffect(() => {
    if (allPaymentLinkFormValues.selectedGym?.value) {
      dispatch(
        fetchAllGymsData({
          page: 1,
          gymid: `gym_id=${allPaymentLinkFormValues.selectedGym.value}`,
          token: decryptedText?.token,
        })
      );
    }

    if (!allPaymentLinkFormValues.selectedGym) {
      setParticularGymAllInfo(null);
    }
  }, [allPaymentLinkFormValues.selectedGym]);

  useEffect(() => {
    if (
      allGymsGstIncludedData?.status &&
      allGymsGstIncludedData?.data?.length > 0
    ) {
      setParticularGymAllInfo(allGymsGstIncludedData.data?.[0]);
    } else {
      setParticularGymAllInfo(null);
    }
  }, [allGymsGstIncludedData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  console.log("paymentLinkFormErrors=> ", paymentLinkFormErrors);

  return (
    <div className="paymentLinkForm mt-0">
      <form className="formContainer">
        <div className="formInputsGrid fourGridSystem">
          {/* DISABLED USER INFO */}
          <>
            <div className="formInputBox">
              <label htmlFor="trainer" className="formInputLabel">
                member name
              </label>

              <input
                type="text"
                className="formInput"
                name="name"
                placeholder={`🚫 ${paymentLinkData?.name || "NA"}`}
                disabled
              />
            </div>
            <div className="formInputBox">
              <label htmlFor="trainer" className="formInputLabel">
                member Mobile
              </label>

              <input
                type="number"
                className="formInput"
                name="number"
                style={{ textTransform: "lowercase" }}
                placeholder={`🚫 ${paymentLinkData?.mobile || "NA"}`}
                disabled
              />
            </div>
            <div className="formInputBox">
              <label htmlFor="trainer" className="formInputLabel">
                member Email
              </label>

              <input
                type="email"
                className="formInput lowercase"
                style={{ textTransform: "lowercase" }}
                name="email"
                placeholder={`🚫 ${
                  paymentLinkData?.email?.toLowerCase() || "NA"
                }`}
                disabled
              />
            </div>
            {
              // !paymentLinkData?.gym_name &&
              isAdmin ? (
                <div className="formInputBox">
                  <label htmlFor="selectedGym" className="formInputLabel">
                    Gym <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      paymentLinkFormErrors.selectedGym && "formError"
                    }`}>
                    <SelectDropdown
                      options={gymData}
                      selectedOption={allPaymentLinkFormValues.selectedGym}
                      setSelectedOption={(selectedValue) =>
                        onChangePaymentLinkForm("selectedGym", selectedValue)
                      }
                      name="Gym"
                    />
                  </div>

                  {/* {(particularGymAllInfo?.poc_name ||
                    particularGymAllInfo?.poc_number) && (
                    <div className="pocNameNumber">
                      <p className="nameNumber">
                        POC Name-
                        <strong>{particularGymAllInfo?.poc_name}</strong>
                      </p>
                      <p className="nameNumber">
                        POC Number-
                        <strong>{particularGymAllInfo?.poc_number}</strong>
                      </p>
                    </div>
                  )} */}
                </div>
              ) : (
                <div className="formInputBox">
                  <label htmlFor="gym" className="formInputLabel">
                    Select Gym
                  </label>

                  <input
                    type="text"
                    className="formInput"
                    name="gym"
                    placeholder={`🚫 ${
                      paymentLinkData?.gym_name
                        ? paymentLinkData.gym_name
                        : allPaymentLinkFormValues.selectedGym?.label ||
                          allPaymentLinkFormValues.selectedGym?.value
                        ? allPaymentLinkFormValues.selectedGym.label ||
                          allPaymentLinkFormValues.selectedGym.value
                        : "NA"
                    }`}
                    disabled
                  />

                  {/* {(particularGymAllInfo?.poc_name ||
                    particularGymAllInfo?.poc_number) && (
                    <div className="pocNameNumber">
                      <p className="nameNumber">
                        POC Name-
                        <strong>{particularGymAllInfo?.poc_name}</strong>
                      </p>
                      <p className="nameNumber">
                        POC Number-
                        <strong>{particularGymAllInfo?.poc_number}</strong>
                      </p>
                    </div>
                  )} */}
                </div>

                // <div className="formInputBox">
                //   <label htmlFor="trainer" className="formInputLabel">
                //     Gym Name
                //   </label>

                // <input
                //   type="text"
                //   className="formInput"
                //   name="gym"
                //   placeholder={`🚫 ${
                //     paymentLinkData?.gym_name
                //       ? paymentLinkData.gym_name
                //       : allPaymentLinkFormValues.selectedGym?.label ||
                //         allPaymentLinkFormValues.selectedGym?.value
                //       ? allPaymentLinkFormValues.selectedGym.label ||
                //         allPaymentLinkFormValues.selectedGym.value
                //       : "NA"
                //   }`}
                //   disabled
                // />
                // </div>
              )
            }
          </>
          {/* ------------ DISABLED USER INFO ------------ */}
          {loading ? (
            <ReactVortoxSpinner />
          ) : (
            <>
              <div className="formInputBox">
                <label htmlFor="selectedPlanType" className="formInputLabel">
                  Plan Type <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    paymentLinkFormErrors.selectedPlanType && "formError"
                  }`}>
                  <SelectDropdown
                    options={planTypes}
                    selectedOption={allPaymentLinkFormValues.selectedPlanType}
                    setSelectedOption={(selectedValue) =>
                      onChangePaymentLinkForm("selectedPlanType", selectedValue)
                    }
                    // setSelectedOption={(selectedValue) =>
                    //   setAllPaymentLinkFormValues({
                    //     ...allPaymentLinkFormValues,
                    //     selectedPlanType: selectedValue,
                    //   })
                    // }
                    name="Plan Type"
                  />
                </div>
              </div>

              {allPaymentLinkFormValues.selectedPlanType?.value ===
              "regular" ? (
                <div className="formInputBox">
                  <label htmlFor="selSourceName" className="formInputLabel">
                    Source Name <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      paymentLinkFormErrors.selSourceName && "formError"
                    }`}>
                    <SelectDropdown
                      options={sourceNames}
                      selectedOption={allPaymentLinkFormValues.selSourceName}
                      setSelectedOption={(selectedValue) =>
                        onChangePaymentLinkForm("selSourceName", selectedValue)
                      }
                      name="Source Name"
                      preventKeyboardOpen={true}
                    />
                  </div>
                </div>
              ) : null}

              {(allPaymentLinkFormValues.selectedPlanType?.value === "addon" ||
                allPaymentLinkFormValues.selectedPlanType?.value ===
                  "addon_pt") && (
                <>
                  <div className="formInputBox">
                    <label htmlFor="selectedAddon" className="formInputLabel">
                      Select Addon <span className="required">*</span>
                    </label>

                    <div
                      className={`commonWrapper ${
                        paymentLinkFormErrors.selectedAddon && "formError"
                      }`}>
                      <SelectDropdown
                        options={allAddons.allAddonsDropdownData}
                        selectedOption={allPaymentLinkFormValues.selectedAddon}
                        setSelectedOption={(selectedValue) =>
                          onChangePaymentLinkForm(
                            "selectedAddon",
                            selectedValue
                          )
                        }
                        name="selectedAddon"
                      />
                    </div>
                  </div>

                  <div className="formInputBox">
                    <label
                      htmlFor="selectedSlotDate"
                      className="formInputLabel">
                      Select slot date <span className="required">*</span>
                    </label>

                    <input
                      type="date"
                      className={`formInput ${
                        paymentLinkFormErrors.selectedSlotDate
                          ? "formError"
                          : ""
                      } ${
                        allPaymentLinkFormValues.selectedSlotDate
                          ? "date-has-value"
                          : ""
                      }`}
                      name="selectedSlotDate"
                      value={allPaymentLinkFormValues.selectedSlotDate}
                      onChange={(e) =>
                        setAllPaymentLinkFormValues({
                          ...allPaymentLinkFormValues,
                          selectedSlotDate: e.target.value,
                        })
                      }
                      min={currentMonthCurrentDate}
                    />
                  </div>

                  {allPaymentLinkFormValues.selectedAddon && (
                    <div className="formInputBox">
                      <label
                        htmlFor="selectedSession"
                        className="formInputLabel">
                        Select session <span className="required">*</span>
                      </label>

                      <div
                        className={`commonWrapper ${
                          paymentLinkFormErrors.selectedSession && "formError"
                        }`}>
                        <SelectDropdown
                          options={allAddons.allSessionsDropdownData}
                          selectedOption={
                            allPaymentLinkFormValues.selectedSession
                          }
                          setSelectedOption={(selectedValue) =>
                            onChangePaymentLinkForm(
                              "selectedSession",
                              selectedValue
                            )
                          }
                          // setSelectedOption={(selectedValue) =>
                          //   setAllPaymentLinkFormValues({
                          //     ...allPaymentLinkFormValues,
                          //     selectedSession: selectedValue,
                          //   })
                          // }
                          name="selectedSession"
                        />
                      </div>
                    </div>
                  )}

                  {allPaymentLinkFormValues.selectedSession?.value && (
                    <div className="formInputBox">
                      <label
                        htmlFor="selectedTrainer"
                        className="formInputLabel">
                        Select Trainer <span className="required">*</span>
                      </label>

                      <div
                        className={`commonWrapper ${
                          paymentLinkFormErrors.selectedTrainer && "formError"
                        }`}>
                        <SelectDropdown
                          options={allTrainerSlotData.trainersDropdownData}
                          selectedOption={
                            allPaymentLinkFormValues.selectedTrainer
                          }
                          setSelectedOption={(selectedValue) =>
                            onChangePaymentLinkForm(
                              "selectedTrainer",
                              selectedValue
                            )
                          }
                          name="selectedTrainer"
                        />
                      </div>
                    </div>
                  )}

                  {/* ------------- SELECT SLOT | SESSION ----------------- */}
                </>
              )}

              {allPaymentLinkFormValues.selectedPlanType?.value ===
                "regular" && (
                <div className="formInputBox">
                  <label htmlFor="selectedPlan" className="formInputLabel">
                    Plan <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      paymentLinkFormErrors.selectedPlan && "formError"
                    }`}>
                    <SelectDropdown
                      options={allPlans.allPlansDropdownData}
                      selectedOption={allPaymentLinkFormValues.selectedPlan}
                      setSelectedOption={(selectedValue) =>
                        onChangePaymentLinkForm("selectedPlan", selectedValue)
                      }
                      name="Plan"
                    />
                  </div>
                </div>
              )}

              <div className="formInputBox">
                <label htmlFor="selectedWhatsapNo" className="formInputLabel">
                  Alternate/Whatsaap Number
                </label>

                <input
                  type="number"
                  className={`formInput ${
                    paymentLinkFormErrors.selectedWhatsapNo && "formError"
                  }`}
                  name="selectedWhatsapNo"
                  placeholder="Enter Alternate/Whatsaap Number"
                  value={allPaymentLinkFormValues.selectedWhatsapNo}
                  onChange={(e) =>
                    setAllPaymentLinkFormValues({
                      ...allPaymentLinkFormValues,
                      selectedWhatsapNo: e.target.value,
                    })
                  }
                />
              </div>

              <div className="formInputBox">
                <label
                  htmlFor="selectedSubsStartDate"
                  className="formInputLabel">
                  Subscription start date <span className="required">*</span>
                </label>

                <input
                  type="date"
                  className={`formInput ${
                    paymentLinkFormErrors.selectedSubsStartDate
                      ? "formError"
                      : ""
                  } ${
                    allPaymentLinkFormValues.selectedSubsStartDate
                      ? "date-has-value"
                      : ""
                  }`}
                  name="selectedSubsStartDate"
                  value={allPaymentLinkFormValues.selectedSubsStartDate}
                  onChange={(e) =>
                    setAllPaymentLinkFormValues({
                      ...allPaymentLinkFormValues,
                      selectedSubsStartDate: e.target.value,
                    })
                  }
                  min={currentMonthCurrentDate}
                />
              </div>

              <>
                {/* {allPaymentLinkFormValues.selectedPlanType?.value ===
                    "regular" &&
                    allPlans.extendableDaysData?.length > 0 && (
                      <div className="formInputBox">
                        <label
                          htmlFor="selectedExtendedDays"
                          className="formInputLabel"
                        >
                          Extend Subscription Days
                        </label>

                        <div
                          className={`commonWrapper ${paymentLinkFormErrors.selectedExtendedDays &&
                            "formError"
                            }`}
                        >
                          <SelectDropdown
                            options={allPlans.extendableDaysData}
                            selectedOption={
                              allPaymentLinkFormValues.selectedExtendedDays
                            }
                            setSelectedOption={(selectedValue) =>
                              onChangePaymentLinkForm(
                                "selectedExtendedDays",
                                selectedValue
                              )
                            }
                            name="Extend Days"
                            isDisable={true}
                          />
                        </div>
                      </div>
                    )} */}
              </>

              {allPaymentLinkFormValues.planExpiryDate !== "Invalid date" && (
                <div className="formInputBox">
                  <label htmlFor="planExpiryDate" className="formInputLabel">
                    Plan Expiry Date
                  </label>

                  <input
                    type="text"
                    className="formInput"
                    name="planExpiryDate"
                    placeholder={`🚫 ${
                      allPaymentLinkFormValues.planExpiryDate || "NA"
                    }`}
                    disabled
                  />
                </div>
              )}

              {/* <div className="formInputBox">
                <label htmlFor="finalBaseAmount" className="formInputLabel">
                  Final Base amount
                </label>

                <input
                  type="number"
                  className="formInput"
                  name="finalBaseAmount"
                  placeholder={`🚫 ${allPaymentLinkFormValues.finalBaseAmount || "NA"
                    }`}
                  disabled
                />
              </div> */}

              <div className="formInputBox">
                <label htmlFor="selectedRequestedBy" className="formInputLabel">
                  requested by
                </label>

                <div
                  className={`commonWrapper ${
                    paymentLinkFormErrors.selectedRequestedBy && "formError"
                  }`}>
                  <SelectDropdown
                    options={
                      individualData && individualData?.length > 0
                        ? individualData
                        : []
                    }
                    selectedOption={
                      allPaymentLinkFormValues.selectedRequestedBy
                    }
                    setSelectedOption={(selectedValue) =>
                      onChangePaymentLinkForm(
                        "selectedRequestedBy",
                        selectedValue
                      )
                    }
                    name="requested by"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>

              {/* PARTIAL || CASH || ONLINE */}
              <>
                {allPaymentLinkFormValues.paymentMode?.value === "partial" && (
                  <>
                    <div className="formInputBox">
                      <label htmlFor="partialCash" className="formInputLabel">
                        Cash <span className="required">*</span>
                      </label>

                      <input
                        type="number"
                        className={`formInput ${
                          paymentLinkFormErrors.partialCash && "formError"
                        }`}
                        name="partialCash"
                        placeholder="Enter Cash Amount"
                        value={allPaymentLinkFormValues.partialCash}
                        onChange={(e) =>
                          setAllPaymentLinkFormValues({
                            ...allPaymentLinkFormValues,
                            partialCash: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="formInputBox">
                      <label htmlFor="partialOnline" className="formInputLabel">
                        Online <span className="required">*</span>
                      </label>

                      <input
                        type="number"
                        className={`formInput ${
                          paymentLinkFormErrors.partialOnline && "formError"
                        }`}
                        name="partialOnline"
                        placeholder="Enter Online Amount"
                        value={allPaymentLinkFormValues.partialOnline}
                        onChange={(e) =>
                          setAllPaymentLinkFormValues({
                            ...allPaymentLinkFormValues,
                            partialOnline: e.target.value,
                          })
                        }
                      />
                    </div>
                  </>
                )}
              </>
              {/* -------------- PARTIAL || CASH || ONLINE -------------- */}
              {/* POC DETAILS */}
              <>
                {/* <div className="formInputBox">
                  <label htmlFor="pocName" className="formInputLabel">
                    POC Name
                  </label>
  
                  <input
                    type="text"
                    className="formInput"
                    name="pocName"
                    placeholder={`🚫 ${paymentLinkData?.name || "NA"}`}
                    disabled
                  />
                </div>
                <div className="formInputBox">
                  <label htmlFor="pocNumber" className="formInputLabel">
                    POC Mobile Number
                  </label>
  
                  <input
                    type="number"
                    className="formInput"
                    name="pocNumber"
                    placeholder={`🚫 ${paymentLinkData?.mobile || "NA"}`}
                    disabled
                  />
                </div> */}
              </>
              {/* ------------ POC DETAILS ------------ */}

              <div className="formInputBox checkBoxLabel span2">
                <input
                  type="checkbox"
                  className="formInput"
                  name="isWhatsaap"
                  checked={allPaymentLinkFormValues.isWhatsapp || false}
                  onChange={(e) =>
                    setAllPaymentLinkFormValues({
                      ...allPaymentLinkFormValues,
                      isWhatsapp: e.target.checked,
                    })
                  }
                />

                <label htmlFor="isWhatsaap" className="formInputLabel">
                  Use Same number for whatsapp
                </label>
              </div>
            </>
          )}
        </div>

        {/* SELECT SLOT */}
        {(allPaymentLinkFormValues.selectedPlanType?.value === "addon" ||
          allPaymentLinkFormValues.selectedPlanType?.value === "addon_pt") && (
          <>
            {allTrainerSlotData?.trainerSlotsInfoData?.[0]?.length > 0 ? (
              <div className="formInputsGrid singleGrid flexWrapMultiBoxontainer bgTransparentShadowNone slotsContainer">
                <div className="formInputBox">
                  <label htmlFor="selectedSlot" className="formInputLabel">
                    Select Slot <span className="required">*</span>
                  </label>

                  <div
                    className={`flexWrapMultiBoxontainerSub ${
                      paymentLinkFormErrors.selectedSlot && "formError"
                    }`}>
                    {allTrainerSlotData?.trainerSlotsInfoData?.[0]?.map(
                      (slot, index) => (
                        <div
                          className={`wrappedBox ${
                            slot?.is_available === false ? "disabledSlot" : ""
                          } ${
                            allPaymentLinkFormValues.selectedSlotIndex === index
                              ? "selected"
                              : ""
                          }`}
                          style={{
                            cursor:
                              slot?.is_available === false
                                ? "not-allowed"
                                : "pointer",
                          }}
                          key={index}
                          onClick={() =>
                            slot?.is_available !== false &&
                            handleSelectSlot(
                              index,
                              slot?.start_time,
                              slot?.end_time,
                              slot?.slot_id
                            )
                          }
                          disabled={slot?.is_available === false}>
                          <span className="wappedValueLabel textSmol">
                            {`${moment(slot?.start_time, "HH:mm")
                              .tz("Asia/Kolkata")
                              .format("h:mm A")} - ${moment(
                              slot?.end_time,
                              "HH:mm"
                            )
                              .tz("Asia/Kolkata")
                              .format("h:mm A")}` || "-"}
                            {/* {`${slot?.start_time} - ${slot?.end_time}` || "-"} */}
                          </span>
                        </div>
                      )
                    )}
                  </div>

                  <>
                    {/* <Row>
                      <Col>
                        <div className="formInputBox">
                          <label
                            htmlFor="selectedSlot"
                            className="formInputLabel"
                          >
                            Morning
                          </label>
                          <div
                            className={`flexWrapMultiBoxontainerSub ${
                              paymentLinkFormErrors.selectedSlot && "formError"
                            }`}
                          >
                            {allTrainerSlotData?.trainerSlotsInfoData?.[0]?.shifts_slot?.morning?.map(
                              (slot, index) => (
                                <div
                                  className={`wrappedBox ${
                                    allPaymentLinkFormValues.selectedSlotIndex ===
                                    index
                                      ? "selected"
                                      : ""
                                  }`}
                                  key={index}
                                  onClick={() => handleSelectPlan(index, slot)}
                                >
                                  <span className="wappedValueLabel textSmol">
                                    {slot || "-"}
                                  </span>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <div className="formInputBox">
                          <label
                            htmlFor="selectedSlot"
                            className="formInputLabel"
                          >
                            Evening
                          </label>
                          <div
                            className={`flexWrapMultiBoxontainerSub ${
                              paymentLinkFormErrors.selectedSlot && "formError"
                            }`}
                          >
                            {allTrainerSlotData?.trainerSlotsInfoData?.[0]?.shifts_slot?.evening?.map(
                              (slot, index) => (
                                <div
                                  className={`wrappedBox ${
                                    allPaymentLinkFormValues.selectedSlotIndex ===
                                    index
                                      ? "selected"
                                      : ""
                                  }`}
                                  key={index}
                                  onClick={() => handleSelectPlan(index, slot)}
                                >
                                  <span className="wappedValueLabel textSmol">
                                    {slot || "-"}
                                  </span>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row> */}
                  </>
                </div>
              </div>
            ) : (
              <span className="errorMessage">Slots Not Available</span>
            )}
          </>
        )}
        {/* ------------------- SELECT SLOT  ------------------- */}

        {/* SELECT PLAN */}
        {selectedPlanAllPrice?.length > 0 ? (
          <div className="formInputsGrid flexWrapMultiBoxontainer">
            <div className="formInputBox">
              <label htmlFor="selectedPrice" className="formInputLabel">
                Choose Plan Price <span className="required">*</span>
              </label>

              <div
                className={`flexWrapMultiBoxontainerSub ${
                  paymentLinkFormErrors.selectedPrice && "formError"
                }`}
                style={{
                  background: "#fff",
                  boxShadow: "none",
                }}>
                {selectedPlanAllPrice?.map((price, index) => (
                  <div
                    className={`wrappedBox ${
                      allPaymentLinkFormValues.selectedPlanIndex === index
                        ? "selected"
                        : ""
                    }`}
                    key={index}
                    onClick={() =>
                      handleSelectPlan(
                        index,
                        price?.plan_price,
                        price?.plan_uid,
                        price?.extend_days || 0
                      )
                    }>
                    <span className="wappedValueLabel textSmol">
                      ₹{price?.plan_price || 0}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {allPaymentLinkFormValues.selectedPlanIndex ? (
              <div className="formInputBox">
                <label
                  htmlFor="selectedExtendedDays"
                  className="formInputLabel">
                  Extend Subscription Days
                </label>

                <input
                  type="number"
                  className="formInput"
                  name="selectedExtendedDays"
                  style={{ textTransform: "lowercase" }}
                  placeholder={`🚫 ${allPaymentLinkFormValues.selectedExtendedDays?.value}`}
                  disabled
                />
              </div>
            ) : null}

            <div className="formInputBox flexStart">
              <label htmlFor="enteredCupon" className="formInputLabel">
                Enter COUPON
              </label>

              <div
                className={`commonWrapper addCuponBtn ${
                  paymentLinkFormErrors.enteredCupon && "formError"
                }`}>
                <input
                  type="text"
                  placeholder="Enter Cupon"
                  className={`formInput ${
                    paymentLinkFormErrors.enteredCupon && "formError"
                  }`}
                  name="enteredCupon"
                  value={allPaymentLinkFormValues.enteredCupon}
                  onChange={(e) =>
                    setAllPaymentLinkFormValues({
                      ...allPaymentLinkFormValues,
                      enteredCupon: e.target.value,
                    })
                  }
                />

                {isAppliedCupon ? (
                  <button className="applyBtn appliedBtn">Applied</button>
                ) : (
                  <button className="applyBtn" onClick={onClickApplyCupon}>
                    Apply
                  </button>
                )}
              </div>

              {allOffers?.allPublicOffers?.length > 0 && (
                <div className="addonRowFlexWrapContainer">
                  {allOffers?.allPublicOffers?.map((offer, index) => (
                    <div
                      className={`wrappedBox ${
                        allPaymentLinkFormValues.selectedOfferIndex === index
                          ? "selected"
                          : ""
                      }`}
                      key={index}
                      onClick={() => handleSelectOffer(index, offer)}>
                      <p className="nameTag" style={{ marginBottom: "0" }}>
                        {offer?.name || "N/A"}
                      </p>
                      {offer?.type === "flat" ? (
                        <span className="subnameTag">
                          Flat ₹{offer?.value} OFF
                        </span>
                      ) : (
                        <span className="subnameTag">{offer?.value}% OFF</span>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="formInputBox flexStart">
              <label htmlFor="paymentMode" className="formInputLabel">
                Payment mode <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  paymentLinkFormErrors.paymentMode && "formError"
                }`}>
                <SelectDropdown
                  options={paymentModes}
                  selectedOption={allPaymentLinkFormValues.paymentMode}
                  setSelectedOption={(selectedValue) =>
                    onChangePaymentLinkForm("paymentMode", selectedValue)
                  }
                  // setSelectedOption={(selectedValue) =>
                  //   setAllPaymentLinkFormValues({
                  //     ...allPaymentLinkFormValues,
                  //     paymentMode: selectedValue,
                  //   })
                  // }
                  name="paymentMode"
                />
              </div>
            </div>
          </div>
        ) : (
          <span className="errorMessage">Price Not Available</span>
        )}
        {/* ------------------- SELECT PLAN ------------------- */}

        {(allPaymentLinkFormValues.selectedPlanType?.value === "addon" ||
          allPaymentLinkFormValues.selectedPlanType?.value === "addon_pt") &&
          !allPaymentLinkFormValues.trainer_exp_lvl && (
            <span className="errorMessage">Experience Level Is NULL</span>
          )}

        {/* DESCRIPTION | TEXTAREA */}
        <>
          {/* {(allPaymentLinkFormValues.paymentMode?.value === "online" ||
              allPaymentLinkFormValues.paymentMode?.value === "partial") && (
              <div className="formInputsGrid textareaGridContainer">
                <div className="formInputBox">
                  <label htmlFor="description" className="formInputLabel">
                    Description *
                  </label>

                  <textarea
                    name="description"
                    className={`formInput ${
                      paymentLinkFormErrors.description && "formError"
                    }`}
                    value={allPaymentLinkFormValues.description}
                    onChange={(e) =>
                      setAllPaymentLinkFormValues({
                        ...allPaymentLinkFormValues,
                        description: e.target.value,
                      })
                    }
                  ></textarea>
                </div>
              </div>
            )} */}
        </>
        {/* ------------------- DESCRIPTION | TEXTAREA ------------------- */}

        {/* GST CALCULATION TABLE */}
        <div className="chargesTableContainer">
          <table className="chargesTable">
            <thead>
              <tr>
                <th>Charges</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Amount</th>
                <td>₹{gstTableValues.amount || "-"}</td>
              </tr>
              <tr>
                <th>Taxable Amount</th>
                <td>₹{gstTableValues.taxableAmount || "-"}</td>
              </tr>
              <tr>
                <th>SGST</th>
                <td>₹{gstTableValues.sgst || "-"}</td>
              </tr>
              <tr>
                <th>CGST</th>
                <td>₹{gstTableValues.cgst || "-"}</td>
              </tr>
              <tr>
                <th style={{ borderBottom: "none" }}>
                  <strong>Total Amount</strong>
                </th>
                <td style={{ borderBottom: "none" }}>
                  <strong>₹{gstTableValues.totalAmount || "-"}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* -------------------- GST CALCULATION TABLE -------------------- */}

        {/* Cash Verification QR Code */}
        {showCashQR && cashDraftId && (
          <CashVerificationQR
            cashDraftId={cashDraftId}
            onVerified={handleCashVerified}
          />
        )}

        <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          {!showCashQR && (
            <Button
              className="saveBtn"
              variant="danger"
              onClick={onClickSendPaymentLink}>
              Send Payment link
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};

export default PaymentLinkForm;
